import path from 'path';

import { TopologyService } from '~services';

import PrivacyPolicyDocument from '../interfaces/privacyPolicyDocument';

/**
 * A service to read the legal documents Topology publishes. The same
 * documents are shown by the mobile apps, so the portal must not link to a
 * hard coded url: the policy can be specific to an organisation.
 */
class PrivacyPolicyDocumentService extends TopologyService {
	protected readonly path = 'documents';

	constructor() {
		super('v1');
	}

	/**
	 * Get the privacy policy document with a url per culture
	 * @returns
	 */
	async getPrivacyPolicy(): Promise<PrivacyPolicyDocument> {
		const { data } = await this._client.get<PrivacyPolicyDocumentResponse>(
			path.join(this.path, 'privacypolicy')
		);

		return PrivacyPolicyDocumentService.fromResponse(data);
	}

	static fromResponse(data: PrivacyPolicyDocumentResponse): PrivacyPolicyDocument {
		return {
			id: data.id ?? undefined,
			organisationId: data.organisationId ?? undefined,
			localizations: (data.localizations ?? []).map((localization) => ({
				cultureCode: localization.cultureCode,
				url: localization.url,
			})),
		};
	}
}

interface PrivacyPolicyDocumentResponse {
	id?: number | null;
	organisationId?: number | null;
	localizations?: {
		cultureCode: string;
		url: string;
	}[];
}

export default PrivacyPolicyDocumentService;
